(ns practitest.frontend.forms3.entity-form.collab-events
  (:require [re-frame.core :as re-frame]))

(re-frame/reg-event-db
  ::update-online-user
  (fn [db [_ user]]
       (update-in db [:online-users (:id user)]
                  (fn [existing-user]
                      (if existing-user
                        (-> existing-user
                            (assoc :state (:state user))
                            (assoc :location (set [(:location user)])))
                        user)))))

(re-frame/reg-event-db
  ::set-form-touched
  (fn [db [_ form-id touched?]]
    (assoc-in db [:form-states2 form-id :touched?] touched?)))

(re-frame/reg-event-db
  ::set-presence-users
  (fn [db [_ projects]]
      (let [online-users (->> (vals projects)
                              (apply concat)
                              distinct
                              (map (fn [{:keys [id] :as user}]
                                       [id
                                        (update user :location
                                                (fn [location]
                                                    (set [location])))]))
                              (into {}))]
           (assoc db :online-users online-users))))

(def user-editing-colors ["#FFCD29" "#3967F2" "#363636" "#F07800"])

(defn- editing-users-path
  "Returns the path to the editing users for a specific form and field"
  [form-id field-id]
  [:form-states2 form-id :fields (keyword field-id) :editing-users])

(defn assign-user-color [form-state user]
  (let [all-editing-users (->> (get-in form-state [:fields])
                               (vals)
                               (mapcat :editing-users)
                               (map :id)
                               (distinct))
        existing-user-idx (.indexOf all-editing-users (:id user))
        user-idx (if (>= existing-user-idx 0)
                   existing-user-idx
                   (count all-editing-users))]
    (assoc user :color (nth user-editing-colors
                            (mod user-idx (count user-editing-colors))))))

(defn- other-users [user-id users]
  "Returns a set of user excluding the current user"
  (filter #(not= (:id %) user-id) users))

(re-frame/reg-event-db
  ::set-field-editing-user
  (fn [db [_ form-id field-id user]]
    (let [path (editing-users-path form-id field-id)
          current-field-users (get-in db path [])
          ;; Remove user if already in list, then add with new color
          filtered-users (other-users (:id user) current-field-users)
          form-state (get-in db [:form-states2 form-id])
          user-with-color (assign-user-color form-state user)
          updated-users (conj filtered-users user-with-color)]
      (assoc-in db path updated-users))))

(re-frame/reg-event-db
  ::clear-field-editing-user
  (fn [db [_ form-id field-id user-id]]
    (let [path (editing-users-path form-id field-id)
          current-users (get-in db path [])
          updated-users (other-users user-id current-users)]
      (if (empty? updated-users)
        (update-in db [:form-states2 form-id :fields (keyword field-id)] dissoc :editing-users)
        (assoc-in db path updated-users)))))

(re-frame/reg-sub
  ::field-editing-users
  (fn [db [_ form-id field-id]]
    (get-in db (editing-users-path form-id field-id) [])))

(re-frame/reg-sub
  ::user-editing-color
  (fn [db [_ form-id user-id]]
    (let [form-fields (get-in db [:form-states2 form-id :fields] {})
          editing-user (->> form-fields
                           (vals)
                           (mapcat :editing-users)
                           (filter #(= (:id %) user-id))
                           (first))]
      (:color editing-user))))

(re-frame/reg-sub
  ::all-editing-users-colors
  ;; Gets all users currently editing fields in the form
  (fn [db [_ form-id]]
    (let [form-fields (get-in db [:form-states2 form-id :fields] {})
          editing-users (->> form-fields
                            (vals)
                            (mapcat :editing-users)
                            (filter some?))]
      (reduce (fn [acc user]
                (assoc acc (:id user) (:color user)))
              {}
              editing-users))))
